import Risks from './Risks';

export default Risks;
